import { render, staticRenderFns } from "./SelfTestPelletizingCalList.vue?vue&type=template&id=31312573&"
import script from "./SelfTestPelletizingCalList.vue?vue&type=script&lang=js&"
export * from "./SelfTestPelletizingCalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports